export const SearchResultState = {
	UNLOADED: 'unloaded',
	LOADING: 'loading',
	LOADED: 'loaded'
};